<div class="popover-header">
  <h2 mat-dialog-title>{{ pot.title }}</h2>
  <button
    mat-icon-button
    class="close-btn"
    (click)="close()"
    aria-label="Close"
  >
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content class="details-content">
  <div class="recurrence-note" *ngIf="pot.recurrenceId">
    <mat-icon inline="true">repeat</mat-icon> Part of a recurring series
  </div>

  <div class="detail-row">
    <mat-icon>schedule</mat-icon>
    <div>
      <div>
        {{ displayDate(pot.startDate)
        }}<span *ngIf="pot.endDate !== pot.startDate">
          – {{ displayDate(pot.endDate) }}</span
        >
      </div>
      <div class="detail-sub" *ngIf="pot.startTime">
        {{ pot.startTime }}<span *ngIf="pot.endTime"> - {{ pot.endTime }}</span>
        <span *ngIf="data.timeZoneLabel"> {{ data.timeZoneLabel }}</span>
        <span *ngIf="durationLabel"> ({{ durationLabel }})</span>
      </div>
      <div class="detail-sub" *ngIf="!pot.startTime">All day</div>
    </div>
  </div>

  <div class="detail-row" *ngIf="pot.location">
    <mat-icon>location_on</mat-icon>
    <a
      *ngIf="locationHref"
      [href]="locationHref"
      target="_blank"
      rel="noopener"
      >{{ pot.location }}</a
    >
    <span *ngIf="!locationHref">{{ pot.location }}</span>
  </div>

  <div class="detail-row">
    <mat-icon>person</mat-icon>
    <span>{{ pot.tutor }}</span>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end" *ngIf="!pot.recurrenceId">
  <button mat-button class="edit-btn" (click)="edit('occurrence')">Edit</button>
  <button
    mat-button
    color="warn"
    class="delete-btn"
    (click)="delete('occurrence')"
  >
    Delete
  </button>
</mat-dialog-actions>

<mat-dialog-actions align="end" *ngIf="pot.recurrenceId">
  <button mat-button class="edit-btn" [matMenuTriggerFor]="editMenu">
    Edit <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
  </button>
  <mat-menu #editMenu="matMenu">
    <ng-container *ngIf="pot.bseId != null">
      <button mat-menu-item (click)="edit('occurrence')">
        Edit this class
      </button>
      <button mat-menu-item (click)="edit('following')">
        This and all following events
      </button>
    </ng-container>
    <ng-container *ngIf="pot.bseId == null">
      <button mat-menu-item (click)="edit('occurrence')">This event</button>
      <button mat-menu-item (click)="edit('following')">
        This and all following events
      </button>
      <button mat-menu-item (click)="edit('series')">
        All events in the series
      </button>
    </ng-container>
  </mat-menu>

  <button
    mat-button
    color="warn"
    class="delete-btn"
    [matMenuTriggerFor]="deleteMenu"
  >
    Delete <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
  </button>
  <mat-menu #deleteMenu="matMenu">
    <button mat-menu-item (click)="delete('occurrence')">This event</button>
    <button mat-menu-item (click)="delete('following')">
      This and all following events
    </button>
    <button mat-menu-item (click)="delete('series')">
      All events in the series
    </button>
  </mat-menu>
</mat-dialog-actions>
